import React from 'react';
export function Footer() {
  return <footer className="bg-brown text-cream/60 py-12 text-center text-sm" data-id="element-37">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-38">
        <p className="mb-4" data-id="element-39">
          © {new Date().getFullYear()} Protocolo Cortisol Off™. Todos los
          derechos reservados.
        </p>
        <p className="text-xs text-cream/40 max-w-2xl mx-auto leading-relaxed" data-id="element-40">
          Este producto no sustituye el consejo médico profesional. Los
          resultados pueden variar de persona a persona. Consulta a tu médico
          antes de comenzar cualquier programa de bienestar.
        </p>
      </div>
    </footer>;
}